import React, { useState, useEffect } from "react";
import { Document, Page } from "react-pdf";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./PDFCarousel.css";

const PDFCarousel = ({ pdfFile }) => {
  const [numPages, setNumPages] = useState(null);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 10000,
    arrows: true,
    centerMode: true,
    centerPadding: "0px",
    adaptiveHeight: true,
  };

  return (
    <div style={{ width: "80%", margin: "auto" }}>
      <Document
        file={pdfFile}
        loading={
          <div className="text-center p-4">
            Loading the Recruitment Flyer...
          </div>
        }
        onLoadSuccess={({ numPages }) => setNumPages(numPages)}
      >
        <Slider {...settings}>
          {Array.from(new Array(numPages), (el, index) => (
            <div key={index}>
              <Page
                pageNumber={index + 1}
                width={window.innerWidth < 992 ? window.innerWidth * 0.7 : 650}
                renderAnnotationLayer={false}
                renderTextLayer={false}
              />
            </div>
          ))}
        </Slider>
      </Document>
    </div>
  );
};

export default PDFCarousel;
